import { createSelector } from 'reselect';
import { getMachine } from 'lib/selectors/getMachine';

export const getPartOperationFingerprint = createSelector(
  [getMachine],
  (machine) => {
    return machine?.partOperationFingerprint || null;
  }
);
